import { render } from "./VratioTrend.vue?vue&type=template&id=623830b6&scoped=true"
import script from "./VratioTrend.vue?vue&type=script&lang=js"
export * from "./VratioTrend.vue?vue&type=script&lang=js"

import "./VratioTrend.vue?vue&type=style&index=0&id=623830b6&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623830b6"]])

export default __exports__